import React from 'react';
import { twMerge } from 'tailwind-merge';
import { RadioButton } from '@repo/common';

const PostRadioGroup = ({
  label,
  required = false,
  options = [],
  value,
  onChange,
  disabled = false,
  className,
  children,
}) => {
  return (
    <div className={twMerge('w-full flex flex-col gap-2', className)}>
      <div className='flex items-center gap-0.5'>
        <span className='typo-b12Strong tabletH:typo-b16 text-text-primary'>
          {label}
        </span>
        {required && <span className='typo-b16Strong text-text-accent'>*</span>}
      </div>

      <div className='w-full rounded-lg tabletH:border tabletH:border-grayscale-gray02 bg-grayscale-gray00'>
        {options.map((option, index) => (
          <div
            key={option.value}
            className={twMerge(
              'h-9 tabletH:h-12 tabletH:px-4 flex items-center gap-2',
              index > 0 && 'tabletH:border-t tabletH:border-grayscale-gray02',
            )}
          >
            <RadioButton
              checked={value === option.value}
              onChange={() => {
                if (!disabled) {
                  onChange?.(option.value);
                }
              }}
              ariaLabel={option.label}
            />
            <span
              className={twMerge(
                'typo-b14 tabletH:typo-b16 flex items-center gap-2',
                disabled ? 'text-text-disable' : 'text-text-tertiary',
              )}
            >
              {option.label}
              {option.value === 'fixed' && children}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PostRadioGroup;
